<template>
  <span>
    <Overlay v-if="overlayPopup" class="z-4 inset-0"/>
    <div ref="searchWrapper">
      <div :class="{ active: show }"
           class="flex items-center z-4 relative main-search bg-white rounded-tl-lg rounded-tr-lg">
      <niceone-search
          id="search"
          v-model="search"
          :clearable="false"
          :placeholder="$t('search.what_are_you_looking_for')"
          :show-action="!!search && show"
          class="w-full"
          @focus="showSearch"
          @search="searchWord"
          @keyup.enter="searchWord">
        <template #action>
          <van-icon color="#bdbdbd" name="clear" size="24" @click="search = ''"/>
        </template>
      </niceone-search>
    </div>
    <div v-if="show"
         class="max-h-[430px] min-h-[150px] overflow-y-auto bg-white absolute z-20 w-full auto-complete rounded-bl-md rounded-br-md">
      <van-loading v-if="isLoading" :size="32" class="absolute inset-0 h-full flex-center"/>
      <search-list v-if="!isLoading && debouncedSearch" :search="debouncedSearch" @close="closeSearch"/>
      <div v-if="!isLoading && !search" class="p-3">
        <stored-searched-word @closeSearch="closeSearch"/>
        <popular-search-words :trends="trends" @setSearch="setSearch"/>
        <brand-section :trends="trends"/>
      </div>
    </div>
  </div>
  </span>
</template>

<script setup>
import StoredSearchedWord from "@/components/home/StoredSearchedWord"
import PopularSearchWords from "@/components/home/PopularSearchWords"
import BrandSection from "@/components/home/BrandSection"
import {getSearchTrends} from "@/plugins/API/search";
import SearchList from "@/components/home/SearchList";
import Overlay from "@/components/common/Overlay.vue";
import {recentSuggestionWord} from "@/composables/useStoreWord";
import {onClickOutside,useDebounce} from "@vueuse/core";
import {track} from "@/composables/useTrackEvent";
import {TRACKERS} from "@/constants/events";

const props = defineProps({
  overlayPopup: {
    type: Boolean,
    default: false,
  },
});
const router = useRouter();
const localPath = useLocalePath()
const show = ref(false);
const overlayPopup = ref(false);

const route = useRoute()
const search = ref(props.initialValue || route.query?.q || "");
const debouncedSearch = useDebounce(search, 500)

const emit = defineEmits(["update:overlayPopup"]);
const enabled = computed(() => props.modelValue);
const {isLoading, data} = getSearchTrends({
  enabled,
});
const trends = computed(() => data?.value || {});
const onCancel = () => {
  if (show.value) {
    track(TRACKERS.SEARCH_TERM, {
      eventLabel: search.value,
      eventAction: 'close'
    })
  }
  show.value = false;
  overlayPopup.value = false;
}

const searchWord = () => {
  track(TRACKERS.SEARCH_TERM, {
    eventLabel: search.value,
    eventAction: 'search_term'
  })
  show.value = false
  overlayPopup.value = false
  recentSuggestionWord({term: search.value, search_query: search.value})
  router.push(localPath({path: '/search', query: {q: search.value}}))
}
const showSearch = () => {
  track(TRACKERS.SEARCH_INITATE)
  show.value = true;
  overlayPopup.value = true;
}
const closeSearch = () => {
  show.value = false
  overlayPopup.value = false
}
const searchWrapper = ref(null)
onClickOutside(searchWrapper, () => {
  closeSearch()
  onCancel()
})

const setSearch = (keyword) => {
  search.value = keyword
  closeSearch()
}
</script>

<style>
.main-search .van-search__content {
  height: 45px;
  align-items: center;
}

.main-search .van-search {
  padding: 0;
  border-radius: 4px;
}

.active .van-search__content {
  border-radius: 4px 4px 0 0 !important;
  border-bottom: 1px solid #e1e1e1;
  background: #fff;
}

.active .van-search__action {
  height: 45px;
  border-bottom: 1px solid #e1e1e1;
  background: #fff;
  display: flex;
  align-items: center;
  border-radius: 4px 4px 0 0 !important;
}

.auto-complete::-webkit-scrollbar {
  width: 6px;
  background: #f5f5f5;
}

.auto-complete::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #e2e2e2;
}
</style>
